// Module
var code = "<div class=bible> <div class=bibletext> <p> </p><h2 class=pn>Psalm&nbsp;110</h2><p><span class=cwvnum>1</span>&nbsp;&nbsp;The Lord said to my lord, &#145;Sit at my right hand,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;until I make your enemies your footstool.&#146;<br> </p> </div></div>";
// Exports
module.exports = code;